import Styles from './MonaDivider.module.css'

export interface MonaDividerProps {
  variant: 'black' | 'purple' | 'pearl'
}

export const defaultProps: Partial<MonaDividerProps> = {}

export const MonaDivider = (props: MonaDividerProps) => {
  const initializedProps: MonaDividerProps = {...defaultProps, ...props}
  // eslint-disable-next-line no-empty-pattern
  const {} = initializedProps

  return <div className={Styles['MonaDivider']}>MonaDivider</div>
}
